import { FilterField } from "kontrolEdge/helpers/advancedFilters";
import { CarrierBridgeRow } from "./CarrierBridgeData";

/**
 * Searchbar fields of the Carrier Bridge admin list. The admin sees every
 * tenant, so Tenant is a regular field rather than the partner-view Customer
 * column of the product lists.
 */
export function makeCarrierBridgeFields(): FilterField<CarrierBridgeRow>[] {
  return [
    {
      label: "Id",
      key: "id",
      accessor: (r) => r.serviceId,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Name",
      key: "name",
      accessor: (r) => r.name,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Status",
      key: "status",
      accessor: (r) => (r.isDraft ? "Draft" : "Active"),
      type: "string",
      inFreeText: true,
    },
    {
      label: "Tenant",
      key: "tenant",
      accessor: (r) => r.tenantName,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Port",
      key: "port",
      accessor: (r) => r.portSubid,
      type: "string",
      inFreeText: true,
    },
    {
      label: "VLAN",
      key: "vlan",
      accessor: (r) => r.vlanLabel,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Carrier",
      key: "carrier",
      accessor: (r) => r.carrierName,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Mbps",
      key: "mbps",
      accessor: (r) => r.mbps,
      type: "number",
    },
  ];
}
